var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRestaurantOptimized(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 62,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.646 32.609 3.774-3.774-8.254-8.24c-.64-.64-1.746-.466-2.146.36a5.355 5.355 0 0 0 1.04 6.08l5.586 5.574Zm9.04-2.414c2.04.947 4.907.28 7.027-1.84 2.547-2.546 3.04-6.2 1.08-8.16-1.947-1.946-5.6-1.466-8.16 1.08-2.12 2.12-2.787 4.987-1.84 7.027l-12.08 12.08a1.33 1.33 0 1 0 1.88 1.88l8.253-8.227 8.24 8.24a1.328 1.328 0 0 0 2.169-.43 1.329 1.329 0 0 0-.289-1.45l-8.24-8.24 1.96-1.96Z",
    fill: "#02E4C0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestaurantOptimized);
export default __webpack_public_path__ + "static/media/restaurant-optimized.54c8f38d56466aaf552a7acfd663e541.svg";
export { ForwardRef as ReactComponent };